import React from "react";
import { Modal } from "react-bootstrap";
import AttachmentBrowser from "../forms/AttachmentBrowser"; // adjust import path
import styles from "../forms/CommunicationForm.module.css";

export default function AttachmentBrowserModal({
  show,
  onClose,
  selectedPatient,
  fhirClient,
  setSelectedDocuments,
}) {
  const patientName =
    selectedPatient?.name?.[0]?.given?.join(" ") + " " + selectedPatient?.name?.[0]?.family;

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title>Documents for {patientName}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBodyDark}>
        <AttachmentBrowser
          selectedPatient={selectedPatient}
          fhirClient={fhirClient}
          onAttach={(wrappedAttachments) => {
            setSelectedDocuments(wrappedAttachments); // store in state
            onClose(); // close modal after selection
          }}
          onClose={onClose} // fallback close button
        />
      </Modal.Body>
    </Modal>
  );
}
